module.exports = __webpack_public_path__ + "static/media/layers.e4de8cf8.svg";